<template>
  <TsRow append-class="m-0 pr-1">
    <TsCard appendClass="p-0 shadow-none min-w-[400px] max-w-[404px]" :data-testid="baseDataTestId + 'section'">
      <TsImage class='rounded-t-xl' width="427" height="218" :src="props.image" alt="card-image" :data-testid="baseDataTestId + 'card-image'" loading="lazy"/>
      <TsColumn append-class="p-3 pb-0" :data-testid="baseDataTestId + 'tag-section'">
        <TsTag size="sm" variant="info" append-class="py-0.5" rounded>
          DIY
        </TsTag>
        <TsTag size="sm" variant="info" append-class="py-0.5" rounded>15
          minutes</TsTag>
      </TsColumn>
      <TsColumn append-class="p-3">
        <TsTypography weight="semibold" appendClass="text-idle-black mb-2" :data-testid="baseDataTestId + 'heading'"><div v-html="props.heading" /></TsTypography>
        <TsTypography :data-testid="baseDataTestId + 'description'"><div v-html="props.description" /></TsTypography>
        <TsTypography :data-testid="baseDataTestId + 'read-more'" weight="semibold" append-class="text-idle-black underline text-nowrap cursor-pointer mt-3">
          Read more</TsTypography>
      </TsColumn>
    </TsCard> 
  </TsRow>
</template>

<script setup lang="ts">
const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

 type Props = {
  image?: string;
  heading?: string;
  description?: string;
};

const props = withDefaults(defineProps<Props>(), {
  image: "/images/dewaltCarousel1.webp",
  heading: "Dream Carpenter Workshop",
  description: "A carpenter workshop requires careful planning and consideration of various factors to ensure functionality...."
});

const baseDataTestId = "card-feature-blog-";

</script>